export interface UserContact {
  uniqueid: string;
  username: string;
  name: string;
  phone: string | null;
  mail: string | null;
  jobTitle: string | null;
  countriesContactEmail: string | null;
}

export interface PersonInfo {
  name: string;
  initials: string;
}
